<template>
  <div class="row">
    <indication-picker
      ref="picker"
      :model-tree="modelTree"
      :tooth-number="currToothNumber"
      v-on:remove="removeTooth"
      v-on:save="handlePickIndication"
    ></indication-picker>
    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
      <div class="row" v-show="loaded && !saving">
        <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
          <a v-on:click="updateTargetJaw('upper')" :class="['fullw', 'btn', 'btn-default', 'btn-lg', {'btn-grey': (currFocus == 'upper')}]">
            <span class="upperjaw"></span>
          </a>
        </div>
        <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
          <a v-on:click="updateTargetJaw('lower')" :class="['fullw', 'btn', 'btn-default', 'btn-lg', {'btn-grey': (currFocus == 'lower')}]">
            <span class="lowerjaw"></span>
          </a>
        </div>
      </div>
      <div class="jaweditor">
        <div
          ref="container"
          class="app3d-main-panel"
          data-gpu="It seems that your graphic card does not support WebGL. Without it we cannot show you the 3D model.<br />Try using another browser."
          data-webgl="Your browser does not support WebGL. Without it we cannot show you the 3D model.<br />Only for modern browsers & IE11+"
        ></div>
      </div>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
      <card :title="$t('Configurator.toothSelection')" v-show="loaded && !saving" body-class="no-padding table-responsive">
        <template slot="buttons">
          <button type="button" class="btn btn-success" v-on:click="save"><i class="fa fa-check"></i> {{ $t('Action.save') }}</button>
        </template>
        <teeth-list :teeth="teethGroups">
          <div class="empty-indicator">
            {{ $t('Configurator.selectTooth') }}
          </div>
        </teeth-list>
        <div class="pad-10">
          <field
            :label="$t('Configurator.showToothNumbers')"
            type="switch"
            :value="showToothNumbers"
            :check-value="true"
            v-on:input="toggleNumberVisibility"
            label-class="col-lg-7 col-md-8 col-sm-9 col-xs-9"
            field-class="col-lg-5 col-md-4 col-sm-3 col-xs-3"
          ></field>
          <div class="clear"></div>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import IndicationPicker from './IndicationPicker.vue';
import TeethList from '../Elements/TeethList.vue';
import swal from 'sweetalert'

var __s__ = require('../Jaws3d/support-fns.js');
var Jaw3DScene = require('../Jaws3d/jaw3d-scene.js');
var Jaw3DConstants = require('../Jaws3d/jaw3d-constants.js');
var jawScene;

var ColorHash = require('color-hash');
var colorHash = new ColorHash();

var view = require('../view.js'),
    viewData = {
      jawScene: null,
      frame: null,
      lastToothNumber: '',
      currToothNumber: '',
      currMouseOverNumber: '',
      currFocus: 'global',
      teeth: [],
      teethGroups: [],
      loaded: false,
      saving: false,
      showToothNumbers: false,
      connectOnClick: false
    },
    resetData = Object.assign({}, viewData);

export default view(viewData, {
  components: {
    IndicationPicker: IndicationPicker,
    TeethList: TeethList
  },
  props: {
    projectId: {},
    modelTree: {}
  },
  computed: {
    hasTeeth() {
      return this.teeth.length > 0;
    }
  },
  methods: {
    reset() {
      for (var i in resetData) {
        if (resetData.hasOwnProperty(i)) {
          viewData[i] = resetData[i];
        }
      }
    },
    createScene() {
      if (jawScene != null && jawScene.isVisible()) {
        this.loaded = true;
        return new Promise(function(resolve, reject) {
          this.openJaw().then(
            resolve
            // this.updateTargetJaw('upper').then(resolve)
          );
        }.bind(this));
      }

      return new Promise(function(resolve, reject) {
        jawScene = new Jaw3DScene.Scene(this.$refs.container, true, true, null, this.handleMouseOver.bind(this), this.handleMouseClick.bind(this));
        // jawScene.freeMove = false;
        jawScene.connectorsVisibility = Jaw3DConstants.VisibilityType.NONE;
        jawScene.numberFormat = Jaw3DConstants.NumberFormat.FDI;

        this.frame = jawScene.getElement();
        __s__.addEventLnr(this.frame, "modelLoaded", function() {
          __s__.addEventLnr(this.frame, "pointerchanged", this.handleMouseOut.bind(this));

          this.loaded = true;
          setTimeout(function() {
            this.openJaw();
            // this.openJaw().then(this.updateTargetJaw('upper'));
            resolve();
          }.bind(this), 2000);
        }.bind(this));

        window.jawScene = jawScene;
      }.bind(this));
    },
    getToothNumber(name) {
      if (name == '') {
        return;
      }
      var ps = name.split("_");
      return ps[jawScene.numberFormat === Jaw3DConstants.NumberFormat.UNS ? 0 : 1].split("-")[1];
    },
    handleMouseOver(toothName) {
      let toothNumber, tooth;
      if (!toothName) {
        return;
      }

      toothNumber = this.getToothNumber(toothName);

      if (this.currMouseOverNumber !== toothNumber) {
        //Prev moused-over
        if (this.currMouseOverNumber) {
          tooth = jawScene.getTooth(this.currMouseOverNumber);
          tooth.setTexture(tooth.__prevhoveredMaterial, false);
        }

        //New moused-over
        tooth = jawScene.getTooth(toothNumber);
        if (!tooth.__isHighlighted) {
          let op = tooth.opacity;
          tooth.__prevhoveredMaterial = tooth.__material.clone();
          tooth.setTexture("#68fefc", false);
          tooth.opacity = op;
          this.currMouseOverNumber = toothNumber;
        }
      }
    },
    handleMouseOut() {
      if (this.currMouseOverNumber == '') {
        return;
      }

      let tooth = jawScene.getTooth(this.currMouseOverNumber);
      if (!tooth.__isHighlighted) {
        let opc = tooth.opacity;
        tooth.setTexture(tooth.__prevhoveredMaterial);
        tooth.opacity = opc;
      }
      this.currMouseOverNumber = '';
    },
    handleMouseClick(toothName, objectName, mouseEvent) {
      if (!(mouseEvent.button === 0 || !mouseEvent.button)) {
        return; // not main mouse button
      }
      if (!toothName) {
        if (!objectName) { return; }
        // If the object is not a tooth
        if (objectName.indexOf("cn_") === 0) {
          let cn = jawScene.getConnectorByName(objectName.substr(3)),
              parts = objectName.split('_'),
              tooth1 = this.getTooth(this.mapNumberToSchema(parts.pop())),
              tooth2 = this.getTooth(this.mapNumberToSchema(parts.pop()));

          if (tooth1.useEntireRange) {
            cn.toggleConnectorColor(true);
            // console.log('Enforce connector TRUE');
          } else {
            this.updateTeethGroups();
          }
          // console.log('Click connector', cn, tooth1, tooth2);
        }
        return;
      }

      let toothNumber = this.getToothNumber(toothName);

      const lastTooth = this.getTooth(this.lastToothNumber);
      if (lastTooth) {
        if (mouseEvent.shiftKey || mouseEvent.ctrlKey || this.connectOnClick) {
          if (mouseEvent.shiftKey || this.connectOnClick) {
            if (this.connectShift(toothNumber, this.lastToothNumber, lastTooth)) {
              this.connectOnClick = false;
            }
            this.handleMouseOut();
          } else {
            let toothConfig = JSON.parse(JSON.stringify(lastTooth));
            toothConfig.toothNumber = toothNumber;
            this.addTooth(toothConfig);
          }

          this.updateTeethGroups();
          return;
        }
      }

      this.editTooth(toothNumber);
    },
    connectShift(clickedToothNumber, lastToothNumber, lastTooth) {
      if (Array.isArray(lastTooth.appliesTo) && lastTooth.appliesTo.length === 2) {
        if (!__s__.isToothNumberInRange(clickedToothNumber, lastTooth.appliesTo[0],lastTooth.appliesTo[1])) {
          this.handleMouseOut();
          swal('', this.$t('Configurator.invalidTeethInRange', [clickedToothNumber, lastTooth.appliesTo[0],
            lastTooth.appliesTo[1]]), 'error');
          return false;
        }
      }
      clickedToothNumber = this.mapNumberToSchemaToUNS(clickedToothNumber);
      lastToothNumber = this.mapNumberToSchemaToUNS(lastToothNumber);

      let start = (clickedToothNumber < lastToothNumber) ? clickedToothNumber : lastToothNumber,
          end   = (clickedToothNumber < lastToothNumber) ? lastToothNumber : clickedToothNumber;

      let toothConfig, activeConnectors = [];
      for (let toothNumber = start ; toothNumber <= end ; toothNumber++) {
        activeConnectors.push(toothNumber + '_' + (toothNumber + 1));
        toothConfig = JSON.parse(JSON.stringify(lastTooth));
        toothConfig.toothNumber = this.mapNumberToSchema(toothNumber);
        this.addTooth(toothConfig, false);
      }

      this.updateConnectors(activeConnectors);

      return true;
    },
    handleTeethListClicked(tooth) {
      this.editTooth(tooth.toothNumber);
    },
    getTooth(toothNumber) {
      for (var i in this.teeth) {
        if (this.teeth.hasOwnProperty(i)) {
          if (this.teeth[i].toothNumber == toothNumber) {
            return this.teeth[i];
          }
        }
      }

      return null;
    },
    editTooth(toothNumber) {
      this.currToothNumber = toothNumber;
      this.$nextTick(() => {
        this.$refs.picker.reset();
        var tooth = this.getTooth(toothNumber);
        if (tooth != null) {
          this.$refs.picker.load(tooth);
        }
        this.$refs.picker.openDialog();
      });
    },
    removeTooth(toothNumber) {
      var tooth = this.getTooth(toothNumber),
          num = this.mapNumberToSchemaToUNS(tooth.toothNumber),
          teeth = [];

      // Get the teethGroup
      for (var i = 0 ; i < this.teethGroups.length ; i++) {
        if (this.teethGroups[i].range.indexOf(num) > -1) {
          this.teeth.forEach(function(tooth) {
            let tnum = this.mapNumberToSchemaToUNS(tooth.toothNumber);

            if (this.teethGroups[i].range.indexOf(tnum) > -1) {
              this.resetTooth(this.mapNumberToSchema(tnum));
            } else {
              teeth.push(tooth);
            }
          }.bind(this));
        }
      }

      this.teeth = teeth;
      this.updateConnectors();
      this.updateTeethGroups();
    },
    addTooth(newTooth, updateConnectors) {
      var teeth = [];

      this.teeth.forEach(function(tooth) {
        if (tooth.toothNumber < newTooth.toothNumber) {
          teeth.push(tooth);
        }
      }.bind(this));

      newTooth.color = this.materialColor(newTooth);
      if (typeof newTooth.formValues == 'undefined') {
        newTooth.formValues = {};
      }

      newTooth.hasAbutment = typeof newTooth.hasAbutment != 'undefined' && newTooth.hasAbutment == '0' ? false : new Boolean(newTooth.hasAbutment);

      teeth.push(newTooth);
      this.highlightTooth(newTooth.toothNumber, newTooth.color, newTooth.hasAbutment);

      this.teeth.forEach(function(tooth) {
        if (tooth.toothNumber > newTooth.toothNumber) {
          teeth.push(tooth);
        }
      }.bind(this));

      this.teeth = teeth;
      this.lastToothNumber = newTooth.toothNumber;

      if (updateConnectors !== false) {
        this.updateConnectors();
      }

      return newTooth;
    },
    async transferToEntireRange(newTooth) {
      let start = this.mapNumberToSchemaToUNS(newTooth.appliesTo[0]);
      let end = this.mapNumberToSchemaToUNS(newTooth.appliesTo[1]);
      if (start > end) {
        const temp = start;
        start = end;
        end = temp;
      }

      for (let toothNumber = start ; toothNumber <= end ; toothNumber++) {
        if (this.getTooth(this.mapNumberToSchema(toothNumber)) != null) {
          if (await swal(this.$t('Configurator.removeJawSelection'), { buttons: [true, true] })) {
            break;
          } else {
            return false;
          }
        }
      }

      let previousToothNumber = null;
      for (let toothNumber = start ; toothNumber <= end ; toothNumber++) {
        let toothConfig = JSON.parse(JSON.stringify(newTooth));
        toothConfig.toothNumber = this.mapNumberToSchema(toothNumber);

        if (previousToothNumber != null) {
          jawScene.getTooth(toothConfig.toothNumber).disconnect(jawScene.getTooth(previousToothNumber))
          jawScene.getTooth(toothConfig.toothNumber).connect(jawScene.getTooth(previousToothNumber))
        }

        this.addTooth(toothConfig);

        previousToothNumber = toothConfig.toothNumber;
      }

      return true;
    },
    mapNumberToSchema(num) {
      if (jawScene.numberFormat === Jaw3DConstants.NumberFormat.UNS)
        return num;

      return Jaw3DConstants.FdiNumbers[num - 1];
    },
    mapNumberToSchemaToUNS(num) {
      if (jawScene.numberFormat === Jaw3DConstants.NumberFormat.UNS)
        return num;

      return Jaw3DConstants.FdiNumbers.indexOf(Number(num)) + 1;
    },
    eachConnector(callback) {
      let tooth,
          prev,
          connector,
          prevToothNumber = 1,
          t1,
          t2;

      for (let toothNumber = 2 ; toothNumber <= 32 ; toothNumber++) {
        if (prevToothNumber != 16) {
          t1 = jawScene.getTooth(this.mapNumberToSchema(toothNumber));
          t2 = jawScene.getTooth(this.mapNumberToSchema(prevToothNumber));
          connector = jawScene.getConnector(jawScene.getTooth(this.mapNumberToSchema(toothNumber)), jawScene.getTooth(this.mapNumberToSchema(prevToothNumber)));
          if (connector) {
            tooth = this.getTooth(this.mapNumberToSchema(toothNumber));
            prev = this.getTooth(this.mapNumberToSchema(prevToothNumber));

            callback(tooth, prev, connector);
          } else {
            // console.log('No connector!', toothNumber, prevToothNumber);
          }
        }
        prevToothNumber = toothNumber;
      }
    },
    updateConnectors(activeConnectors) {
      if (typeof activeConnectors == 'undefined') {
        activeConnectors = [];
      }

      this.eachConnector((tooth, prev, connector) => {
        if (tooth == null || prev == null) {
          connector.toggleVisibility(false, false);
          connector.isOn = false;
        } else {
          connector.toggleVisibility(
            false,
            prev.itemName && prev.material == tooth.material && prev.itemName == tooth.itemName
          );
          if (activeConnectors.indexOf(connector.name) > -1) {
            connector.toggleConnectorColor(true);
          }
        }
      });
    },
    getConnectors() {
      let connectors = [];

      this.eachConnector((tooth, prev, connector) => {
        if (tooth != null && prev != null) {
          connectors.push(connector);
        }
      });

      return connectors;
    },
    updateTeethGroups() {
      let teethGroups = [];

      this.eachConnector((tooth, prev, connector) => {
        if (prev == null && tooth == null) {
          return;
        }

        var toothNumber1 = prev == null ? null : this.mapNumberToSchemaToUNS(prev.toothNumber),
            toothNumber2 = tooth == null ? null : this.mapNumberToSchemaToUNS(tooth.toothNumber),
            groupIndex = null;

        if (connector.isOn) {
          for (let i = 0 ; i < teethGroups.length ; i++) {
            if (teethGroups[i].range.indexOf(toothNumber1) > -1 || teethGroups[i].range.indexOf(toothNumber2) > -1) {
              if (teethGroups[i].range.indexOf(toothNumber1) > -1 && teethGroups[i].range.indexOf(toothNumber2) == -1)  {
                teethGroups[i].range.push(toothNumber2);
              }
              if (teethGroups[i].range.indexOf(toothNumber2) > -1 && teethGroups[i].range.indexOf(toothNumber1) == -1)  {
                teethGroups[i].range.push(toothNumber1);
              }
              groupIndex = i;
              break;
            }
          }

          if (tooth !== null && groupIndex === null) {
            teethGroups.push({
              color: tooth.color,
              itemName: tooth.itemName,
              requireAttachments: tooth.requireAttachments,
              formValues: tooth.formValues,
              material: tooth.hasOwnProperty('material') ? tooth.material : null,
              itemnums: tooth.hasOwnProperty('itemnums') ? tooth.itemnums : null,
              isFlatrate: tooth.isFlatrate,
              range: [toothNumber1, toothNumber2]
            });
          }
        } else {
          // Add single tooth
          for (let i = 0 ; i < teethGroups.length ; i++) {
            if (toothNumber1 != null && teethGroups[i].range.indexOf(toothNumber1) > -1)  {
              toothNumber1 = null;
            }
            if (toothNumber2 != null && teethGroups[i].range.indexOf(toothNumber2) > -1)  {
              toothNumber2 = null;
            }
          }
          if (toothNumber1 != null) {
            teethGroups.push({
              color: prev.color,
              itemName: prev.itemName,
              requireAttachments: prev.requireAttachments,
              formValues: prev.formValues,
              material: prev.hasOwnProperty('material') ? prev.material : null,
              itemnums: prev.hasOwnProperty('itemnums') ? prev.itemnums : null,
              isFlatrate: prev.isFlatrate,
              range: [toothNumber1]
            });
          }
          if (toothNumber2 != null) {
            teethGroups.push({
              color: tooth.color,
              itemName: tooth.itemName,
              requireAttachments: tooth.requireAttachments,
              formValues: tooth.formValues,
              material: tooth.hasOwnProperty('material') ? tooth.material : null,
              itemnums: tooth.hasOwnProperty('itemnums') ? tooth.itemnums : null,
              isFlatrate: tooth.isFlatrate,
              range: [toothNumber2]
            });
          }
        }
      });

      for (let i = 0 ; i < teethGroups.length ; i++) {
        /*
        teethGroups[i].range.sort(function(a, b) {
          return a - b;
        });
        */
        teethGroups[i].rangeLabel = this.mapNumberToSchema(teethGroups[i].range[0])

        if (teethGroups[i].range.length > 1) {
          teethGroups[i].rangeLabel += '-' + this.mapNumberToSchema(teethGroups[i].range[teethGroups[i].range.length - 1])
        }

        if (teethGroups[i].itemnums) {
          Object.keys(teethGroups[i].itemnums).forEach(key => {
            // @HACK to support flatrate items
            if (teethGroups[i].isFlatrate) {
              teethGroups[i].itemnums[key] = 1;
            } else {
              teethGroups[i].itemnums[key] = teethGroups[i].range.length;
            }
          })
        }
      }

      this.teethGroups = teethGroups;
    },
    highlightTooth(toothNumber, color, hasAbutment) {
      var tooth = jawScene.getTooth(toothNumber);
      if (tooth == null) {
        return;
      }

      tooth.reset();
      tooth.__preclickedMaterial = tooth.__material.clone();
      tooth.setTexture(color, false);
      tooth.__isHighlighted = true;

      if (hasAbutment) {
        tooth.setOpacity(0.5);
        tooth.addExtraModel('DIN 6379 Studs for T-Nuts');
      } else {
        tooth.setOpacity(1);
      }
    },
    resetTooth(toothNumber) {
      var tooth = jawScene.getTooth(toothNumber);
      if (tooth) {
        tooth.reset();
        tooth.setOpacity(1);
      }
    },
    showLabels() {
      jawScene.labelsVisibility = Jaw3DConstants.VisibilityType.SOLID;
    },
    hideLabels() {
      jawScene.labelsVisibility = Jaw3DConstants.VisibilityType.NONE;
    },
    updateTargetJaw(target) {
      let f;
      switch (target) {
        case 'upper':
          if (this.currFocus == 'upper')
            return this.updateTargetJaw();

          f = Jaw3DConstants.FocusJaw.UPPER;
          this.currFocus = 'upper';
          break;
        case 'lower':
          if (this.currFocus == 'lower')
            return this.updateTargetJaw();

          f = Jaw3DConstants.FocusJaw.LOWER;
          this.currFocus = 'lower';
          break;
        default:
          f = Jaw3DConstants.FocusJaw.GLOBAL;
          this.currFocus = 'global';
          break;
      }

      return jawScene.focusScene(f, true, true);
    },
    openJaw(ang) {
      return jawScene.setAngle(typeof ang == 'undefined' ? 180 : ang, 1);
    },
    takeScreenshot() {
      return jawScene.generateScreenshot(400, 600, 'png', true);
    },
    updateHeight() {
      // getBoundingClientRect():
    },
    load(teeth) {
      this.createScene().then(function() {
        jawScene.reset();
        if (typeof teeth != 'undefined') {
          let activeConnectors = [];

          teeth.forEach(function(tooth) {
            this.addTooth(tooth, false);
            if (typeof tooth.connector == 'string') {
              activeConnectors.push(tooth.connector);
            }
          }.bind(this));

          this.updateConnectors(activeConnectors);
          this.updateTeethGroups();
        }
      }.bind(this));
    },
    save() {
      let teeth = [];
      this.eachConnector((tooth, prev, connector) => {
        if (prev != null && (this.mapNumberToSchemaToUNS(prev.toothNumber) == 1 || this.mapNumberToSchemaToUNS(prev.toothNumber) == 17)) {
          teeth.push(prev);
        }
        if (tooth != null) {
          tooth.connector = connector.isOn ? connector.name : null;
          teeth.push(tooth);
        }
      });

      this.saving = true;
      this.openJaw(60).then(
        this.updateTargetJaw('global').then(function() {
          this.toggleNumberVisibility(false);
          this.$emit(
            'save',
            this.takeScreenshot(),
            teeth,
            JSON.parse(JSON.stringify(this.teethGroups))
          );
          this.saving = false;
        }.bind(this))
      );
    },
    backToDetails() {
      this.$emit('goback', true);
    },
    materialColor(tooth) {
      return typeof tooth.color == 'undefined' ? colorHash.hex(tooth.material + tooth.label) : tooth.color;
    },
    toggleNumberVisibility(checked) {
      this.showToothNumbers = checked;
      if (jawScene) {
        jawScene.labelsVisibility = checked ? Jaw3DConstants.VisibilityType.SOLID : Jaw3DConstants.VisibilityType.NONE;
      }
    },
    transferToTeethGroup() {
      // TODO
    },
    async handlePickIndication(newTooth) {
      if (newTooth.useEntireRange) {
        this.transferToEntireRange(newTooth);
      } else {
        let askReplay = null;
        if (newTooth.connect === 'ask') {
          askReplay = await swal(this.$t('Configurator.transferSettings'), { buttons: [true, true] });
        }
        if (newTooth.connect === 'auto' || askReplay) {
          this.connectOnClick = true;
          await swal(this.$t('Configurator.clickOnConnectTooth'));
        }

        this.addTooth(newTooth);
      }

      this.updateTeethGroups();
    }
  }
});
</script>
